var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleChat = function SvgDoubleChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M9.75 15.456h4.707a.375.375 0 0 0 .35-.508l-.373-.985c-.196-.518-.088-1.1.228-1.553.475-.683 1.088-1.741 1.088-2.66M13.5 7.875A5.625 5.625 0 0 1 7.875 13.5H2.793a.375.375 0 0 1-.35-.508l.48-1.269c.172-.454.102-.957-.11-1.393A5.625 5.625 0 1 1 13.5 7.875Z"
  })));
};
export default SvgDoubleChat;